<template>
<div>
  <el-card>
    <div slot="header" class="clearfix">
      <span style="color: #409EFF">芒果号配置</span>
    </div>
    <el-form ref="queryForm" :model="queryForm" >
      <el-row :gutter="4">
        <el-col :span="4.8">
          <el-form-item >
            <el-checkbox v-model="checked"></el-checkbox>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="性别" prop="webTitle">
            <el-radio-group v-model="queryForm.isneedReview" @change="tackReviewChange">
              <el-radio :label="0">男</el-radio>
              <el-radio :label="1">女</el-radio>
            </el-radio-group>
          </el-form-item>
        </el-col>
      </el-row>

      <el-row :gutter="0">
        <el-col :span="3.8">
          <el-form-item >
            <el-checkbox v-model="checked"></el-checkbox>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="淘龄大于等于" prop="webTitle" label-width="27%">
            <el-input v-model="queryForm.webTitle" placeholder="输入淘龄"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="4">
          <el-form-item label="个月" prop="webTitle">
          </el-form-item>
        </el-col>
      </el-row>

      <!--<el-row :gutter="0">
        <el-col :span="3.8">
          <el-form-item >
            <el-checkbox v-model="checked"></el-checkbox>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="限制地区" prop="webTitle" label-width="20%">
            <el-input v-model="queryForm.webTitle" placeholder="输入地区"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="4">
          <el-form-item label="多个地区用，隔开" prop="webTitle">
          </el-form-item>
        </el-col>
      </el-row>-->

      <el-row :gutter="0">
        <el-col :span="3.8">
          <el-form-item >
            <el-checkbox v-model="checked"></el-checkbox>
          </el-form-item>
        </el-col>
        <el-col :span="10">
          <el-form-item label="周购物量小于等于" prop="webTitle" label-width="28%">
            <el-input v-model="queryForm.webTitle" placeholder="请输入"></el-input>
          </el-form-item>
        </el-col>
      </el-row>

      <el-row :gutter="0">
        <el-col :span="3.8">
          <el-form-item >
            <el-checkbox v-model="checked"></el-checkbox>
          </el-form-item>
        </el-col>
        <el-col :span="10">
          <el-form-item label="月购物量小于等于" prop="webTitle" label-width="28%">
            <el-input v-model="queryForm.webTitle" placeholder="请输入"></el-input>
          </el-form-item>
        </el-col>
      </el-row>

      <el-row :gutter="0">
        <el-col :span="3.8">
          <el-form-item >
            <el-checkbox v-model="checked"></el-checkbox>
          </el-form-item>
        </el-col>
        <el-col :span="10">
          <el-form-item label="退款率小于等于" prop="webTitle" label-width="25%">
            <el-input v-model="queryForm.webTitle" placeholder="请输入"></el-input>
          </el-form-item>
        </el-col>
      </el-row>

      <el-row :gutter="0">
        <el-col :span="3.8">
          <el-form-item >
            <el-checkbox v-model="checked"></el-checkbox>
          </el-form-item>
        </el-col>
        <el-col :span="10">
          <el-form-item label="违规记录次数小于等于" prop="webTitle" label-width="33%">
            <el-input v-model="queryForm.webTitle" placeholder="请输入"></el-input>
          </el-form-item>
        </el-col>
      </el-row>

      <el-row :gutter="0">
        <el-col :span="3.8">
          <el-form-item >
            <el-checkbox v-model="checked"></el-checkbox>
          </el-form-item>
        </el-col>
        <el-col :span="10">
          <el-form-item label="平均消费大于等于" prop="webTitle" label-width="27%">
            <el-input v-model="queryForm.webTitle" placeholder="请输入"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="4">
          <el-form-item label="元" prop="webTitle">
          </el-form-item>
        </el-col>
      </el-row>

      <el-row :gutter="0">
        <el-col :span="3.8">
          <el-form-item >
            <el-checkbox v-model="checked"></el-checkbox>
          </el-form-item>
        </el-col>
        <el-col :span="10">
          <el-form-item label="信用分数大于等于" prop="webTitle" label-width="27%">
            <el-input v-model="queryForm.webTitle" placeholder="请输入"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
<!--
      <el-row :gutter="0">
        <el-col :span="3.8">
          <el-form-item >
            <el-checkbox v-model="checked"></el-checkbox>
          </el-form-item>
        </el-col>
        <el-col :span="10">
          <el-form-item label="照妖镜显示删评小于等于" prop="webTitle" label-width="36%">
            <el-input v-model="queryForm.webTitle" placeholder="请输入"></el-input>
          </el-form-item>
        </el-col>
      </el-row>

      <el-row :gutter="0">
        <el-col :span="3.8">
          <el-form-item >
            <el-checkbox v-model="checked"></el-checkbox>
          </el-form-item>
        </el-col>
        <el-col :span="10">
          <el-form-item label="照妖镜显示差评小于等于" prop="webTitle" label-width="36%">
            <el-input v-model="queryForm.webTitle" placeholder="请输入"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="0">
        <el-col :span="3.8">
          <el-form-item >
            <el-checkbox v-model="checked"></el-checkbox>
          </el-form-item>
        </el-col>
        <el-col :span="10">
          <el-form-item label="照妖镜显示敲诈小于等于" prop="webTitle" label-width="36%">
            <el-input v-model="queryForm.webTitle" placeholder="请输入"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="0">
        <el-col :span="3.8">
          <el-form-item >
            <el-checkbox v-model="checked"></el-checkbox>
          </el-form-item>
        </el-col>
        <el-col :span="10">
          <el-form-item label="照妖镜显示骗子小于等于" prop="webTitle" label-width="36%">
            <el-input v-model="queryForm.webTitle" placeholder="请输入"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
-->
    </el-form>
  </el-card>

  <el-card>
    <el-form>
      <el-row :gutter="30" style="text-align: center">
        <el-col span="10" style="text-align: right">
          <el-button type="info" icon="el-icon-back">返回</el-button>
        </el-col>
        <el-col span="10" style="text-align: left">
          <el-button type="primary" icon="el-icon-folder">保存</el-button>
        </el-col>
      </el-row>
    </el-form>
  </el-card>
</div>
</template>

<script>
import MixinCUD from '@/components/MixinCUD'
export default {
  name: "MiniLoveVerifyNumConfig",
  mixins:[MixinCUD],
  data(){
    return {
      tableData:[],
      queryForm:{
        checkList: []
      },
      pagination:{
        pageNum: 1,
        pageSize: 20,
        total: null
      },
    }
  },
  methods: {

  }
}
</script>

<style scoped>
.el-form {
  margin-top: 20px;
  margin-left: 20%;
}

.clearfix:before,
.clearfix:after {
  display: table;
  content: "";
}
.clearfix:after {
  clear: both
}
.demo-input-suffix {
  margin-bottom: 15px;
}
</style>
